export default __webpack_public_path__ + "static/media/c008-board1.729d82e7.svg";